import React from 'react'
import Navbar from '../components/Navbar'
import FullFeatured from '../components/FullFeatured'
import Footer from '../components/Footer'

const FullFeaturedPage = () => {
  return (
    <>
      <Navbar/>
      <FullFeatured/>
      <Footer/>
    </>
  )
}

export default FullFeaturedPage
